import { useState } from 'react'

import Stack from '@mui/material/Stack'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'

import { AddButton, CancelButton, SaveButton } from '../../../../global/Button'
import AddMemberModal from './AddMemberModal'
import { AppModalAlert, useModalState } from '../../../../global/Modal'
import { IUser } from '../../../../../compiler/global.interface'
import { IUserInformationFormValues } from '../User/UserInformation'
import { IUserFormValues } from '../../../../../pages/Setting/Access/User'
import { FieldValues, useFieldArray, UseFormReturn } from 'react-hook-form'
import { useGetAllUsers } from '../../../../../hook/query/userCRUD'
import ActionBar from '../../../../global/Widget/ActionBar'
import { useSettingAccessUserGroupPageContext } from '../../../../../pages/Setting/Access/UserGroup'
import objectSameKeyValue from '../../../../../utilitie/objectSameKeyValue'
import { useAddMemberToGroupByUUID } from '../../../../../hook/query/groupCRUD'
import { useSnackbar } from 'notistack'
import { EHelperText } from '../../../../../utilitie/validation'
export interface IUserGroupManageProps {
    useMemberForm: UseFormReturn<
        { members: IUserGroupMemberFormValues[] },
        object
    >
}

export interface IUserGroupAddMemberFormValues { }

export interface IUserGroupMemberFormValues extends IUserFormValues {
    id: number | null
}

export interface IMemberInGroupFormValues {
    id: any,
    uuid?: string | null
    is_remove: number
}

export default function UserGroupManage({ useMemberForm }: IUserGroupManageProps) {

    const { uuid } = useSettingAccessUserGroupPageContext()
    const { enqueueSnackbar } = useSnackbar()
    const { mutateAsync: addMemberToGroup, isLoading: addMemberToGroupLoading } = useAddMemberToGroupByUUID(uuid)

    const [modalState, setModalState, toggleModalState] = useModalState()

    const { defaultValues } = useSettingAccessUserGroupPageContext()

    const { control, reset, handleSubmit, setValue, getValues, formState: { isValid } } = useMemberForm

    const membersFields = useFieldArray({ control, name: 'members' })

    const handleToggleModal = (openStatus: boolean = !modalState.open) => {
        setModalState({ ...modalState, status: '', open: openStatus })
    }

    const handleAddMember = (e, values) => {
        setValue('members', values)
        toggleModalState(false, '')
        // seIModalState({ ...modalState, status: 'error' })
    }

    const _handleSubmit = async (values: FieldValues) => {

        let checkRemove = defaultValues.useMemberForm.members.map(user => ({
            ...user,
            is_remove: values.members.find(_user => _user.user_uuid === user.user_uuid) ? 0 : 1
        }))

        let payload = { members: [...checkRemove, ...values.members.map(user => ({ ...user, is_remove: 0 }))].filter((v, i, a) => a.findIndex(t => (t.user_uuid === v.user_uuid)) === i) } as { members: IMemberInGroupFormValues[] }

        await addMemberToGroup(payload).then(() => {
            enqueueSnackbar(EHelperText.UPDATED_SUCCESS, { variant: 'success' })
        }).catch((error) => {
            enqueueSnackbar(EHelperText.AN_ERROR_OCCURRED?.replace('กับ', ''), { variant: 'error' })
        })
    }

    const handleDelete = (index) => {
        membersFields.remove(index)
    }

    const handleCancel = () => {
        reset(defaultValues.useMemberForm)
    }

    const isReadyToAction = !addMemberToGroupLoading && isValid

    return (
        <>
            {
                modalState.open && (
                    <AddMemberModal title='เพิ่มสมาชิก กลุ่มจัดการสินค้า' currentMember={getValues().members} open={true} onCancel={() => toggleModalState(false)} onClose={() => toggleModalState(false)} onConfirm={handleAddMember} />
                )
            }
            <AppModalAlert hideBackdrop title='เพิ่มสมาชิก กลุ่มจัดการสินค้า' open={!!modalState.status} status={modalState.status} onClose={() => toggleModalState(false)} />
            <Stack component="form" onSubmit={handleSubmit(_handleSubmit, error => console.error(error))} height={'100%'}>
                <AddButton onClick={() => handleToggleModal(true)} fullWidth variant='contained' sx={{ borderRadius: 0, border: 0, ':hover': { border: 0 } }}>เพิ่มสมาชิก</AddButton>
                <Stack flex={1} overflow={'auto'}>
                    {membersFields?.fields?.map((member, index) => (
                        <Stack key={index} className='row' px={4} py={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ ...(index % 2 === 0 && { bgcolor: 'grey.100' }) }}>
                            <Stack direction={'row'} spacing={1} alignItems={'center'}>
                                <Avatar src={member?.avatar} alt={member?.username} />
                                <Typography>{member?.firstname + ' ' + member?.lastname}</Typography>
                            </Stack>
                            <Box>
                                <IconButton size='small' onClick={() => handleDelete(index)}>
                                    <DeleteIcon sx={{ color: 'error.main' }} />
                                </IconButton>
                            </Box>
                        </Stack>
                    ))}
                </Stack>
                <ActionBar>
                    <CancelButton disabled={!isReadyToAction} onClick={handleCancel}>ยกเลิก</CancelButton>
                    <SaveButton type="submit" disabled={!isReadyToAction}>บันทึก</SaveButton>
                </ActionBar>
            </Stack>
        </>
    );
}
